import React from 'react'

import { ColorWheel, Media } from '@syconium/little-miss-figgy'
import { Dialog, PillButton } from '@syconium/little-miss-figgy/dist/components'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { trackEvent } from '../../../../lib/analytics'

import ColorGalleryModal from './ColorGalleryModal'
import * as Styles from './styles'

type ColorGalleryModalProps = {
  productGroupHandle: string
  minimize?: boolean | undefined
  colorCount: number
}

const ColorGalleryCTA = ({ productGroupHandle, minimize, colorCount }: ColorGalleryModalProps) => {
  const {
    colorGallery: { colorGalleryCTA, title },
  } = useTranslation()

  return (
    <Dialog.Provider>
      <Dialog.Disclosure
        render={
          <PillButton
            allCaps={false}
            {...trackEvent({
              action: 'open color gallery modal',
              category: 'product details',
              value: productGroupHandle,
            })}
          >
            <ColorWheel />
            <Styles.PillText>
              {minimize ? <Media lessThan='lg'>{title}</Media> : colorGalleryCTA}
              {minimize && <Media greaterThanOrEqual='lg'>{colorGalleryCTA}</Media>}
            </Styles.PillText>
          </PillButton>
        }
      />
      <ColorGalleryModal productGroupHandle={productGroupHandle} colorCount={colorCount} />
    </Dialog.Provider>
  )
}

export default ColorGalleryCTA
